module.exports = __webpack_public_path__ + "img/tuscaloosa-city-logo.7d72bd4f.jpg";